/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HttpModule
 */

import { NgModule } from '@angular/core';

import {
    AlbHttpClient,
    ALB_HTTP_INTERCEPTORS,
    EncodeQueryParamsInterceptor,
    HttpErrorHandlingInterceptor,
    ProcessReloadPermissionHeaderInterceptor,
    SetRequestHeadersInterceptor,
    UseRelativePathsInterceptor,
} from '.';

const albHttpInterceptorProviders = [{
    provide: ALB_HTTP_INTERCEPTORS,
    useClass: EncodeQueryParamsInterceptor,
    multi: true,
}, {
    provide: ALB_HTTP_INTERCEPTORS,
    useClass: SetRequestHeadersInterceptor,
    multi: true,
}, {
    provide: ALB_HTTP_INTERCEPTORS,
    useClass: ProcessReloadPermissionHeaderInterceptor,
    multi: true,
}, {
    provide: ALB_HTTP_INTERCEPTORS,
    useClass: HttpErrorHandlingInterceptor,
    multi: true,
}, {
    provide: ALB_HTTP_INTERCEPTORS,
    useClass: UseRelativePathsInterceptor,
    multi: true,
}];

/**
 * @description Module to use AlbHttpClient.
 *
 * @author Aravindh Nagarajan
 */
@NgModule({
    providers: [
        AlbHttpClient,
        albHttpInterceptorProviders,
    ],
})
export class HttpModule {}
